import type { ComponentProps } from "react";
import { Label as LabelPrimitive } from "radix-ui";
import { cn } from "@jbnl/shared-ui";

/**
 * shadcn's Label. Radix rather than a bare `<label>` for the one thing the element cannot do
 * itself: it stops a click on the text from double-firing on the control it points at.
 * `peer-disabled:opacity-50` becomes 45, the disabled step the rest of this palette uses.
 */
export function Label({
  className,
  ...props
}: ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none",
        "group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-45",
        "peer-disabled:cursor-not-allowed peer-disabled:opacity-45",
        className,
      )}
      {...props}
    />
  );
}
